import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const useBranding = () => {
  const { logo_url, primary_color, secondary_color } = useSelector(
    (state: RootState) => state.branding
  );

  useEffect(() => {
    // Apply CSS variables to document root
    const root = document.documentElement;
    
    if (primary_color) {
      root.style.setProperty("--primary-color", primary_color);
      // Also update shadcn/ui primary color if used as --primary
      root.style.setProperty("--primary", primary_color);
    }
    
    if (secondary_color) {
      root.style.setProperty("--secondary-color", secondary_color);
      root.style.setProperty("--secondary", secondary_color);
    }

    // Update favicon if logo exists (optional but premium)
    // const favicon = document.querySelector('link[rel="icon"]');
    // if (favicon && logo_url) {
    //   favicon.setAttribute('href', logo_url);
    // }

  }, [primary_color, secondary_color, logo_url]);

  return useMemo(
    () => ({ logo_url, primary_color, secondary_color }),
    [logo_url, primary_color, secondary_color]
  );
};
